import { render, staticRenderFns } from "./IconDrop.vue?vue&type=template&id=5cae5a2a&scoped=true&"
import script from "./IconDrop.vue?vue&type=script&lang=js&"
export * from "./IconDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae5a2a",
  null
  
)

export default component.exports